import _ from 'lodash'
import timezones from './timezones.json'

export const getTimezones = () => {
    const tz = _.sortBy(timezones, ['name'])
    return _.map(tz, (item) => ({ value: item.name, label: item.name }))
}
